exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-list[data-v-3eac6bac]{max-width:500px;word-wrap:normal;overflow:hidden;text-overflow:ellipsis\n}\n.icon[data-v-3eac6bac]{margin:auto !important\n}\n#btn-delete[data-v-3eac6bac]{color:red\n}\n#btn-delete[data-v-3eac6bac]:hover{transform:scale(1.2);color:red !important;background-color:rgba(0,0,0,0) !important\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-3eac6bac","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/distribution/form-components/SnsShareForm.vue
// module id = 149
// module chunks = 0